import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './app.scss'

import ApiService from './services/api.service'
import ConnectionService from './services/connection.service'
import {TokenService, SettingsService} from './services/storage.service'

Vue.config.productionTip = false

//Global Components
Vue.component('Loading', require('./components/Loading').default)
Vue.component('Unicon', require('./components/Unicon').default)
Vue.component('Hider', require('./components/Animations/Hider').default)
require('./mixin')
window.icons = require('./res/icons');
//call from connection service
window.boot = function () {
  console.log('boot')

  // Set the base URL of the API
  ApiService.init(process.env.VUE_APP_ROOT_API)
  // If token exists set header
  if (TokenService.getToken()) {
    ApiService.setHeader()
    //Mount errors for unauthorised requests
    ApiService.mount401Interceptor()
  }
  //set users settings
  //???
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')

}

//check if online and boot
//  store.commit('internet', false)
//  window.boot();
ConnectionService.init(process.env.VUE_APP_ROOT_API+'api/quiz/internet_connection')